import React, { useMemo } from "react";
import { useParams } from "react-router-dom";

const HotWorkTemplate4 = ({ checklist, signatures }) => {
  const { formId } = useParams();
  const fireSafetySignature = signatures?.find(
    (sig) => sig.type === "fire_safety_officer"
  );

  // Create a map using checklist_item_id as key for O(1) lookup
  const checklistMap = useMemo(() => {
    const map = {};
    checklist?.forEach((item) => {
      map[item.checklist_item_id] = item;
    });
    return map;
  }, [checklist]);

  // Define your checklist item IDs (these are from your data)
  const CHECKLIST_IDS = {
    // Section I - Road Closure
    ROAD_CLOSURE: "281cd23f-d3de-11ef-8bb7-9c2dcdaf01ba",

    // Section I - Items 1-6
    EQUIPMENT_INSPECTED_1: "281db781-d3de-11ef-8bb7-9c2dcdaf01ba",
    AREA_CORDONED: "281dd8da-d3de-11ef-8bb7-9c2dcdaf01ba",
    CLEARANCE_FS: "281ddbc8-d3de-11ef-8bb7-9c2dcdaf01ba",
    FLAME_ARRESTOR: "281ddc44-d3de-11ef-8bb7-9c2dcdaf01ba",
    DANGER_SIGN: "281ddcb0-d3de-11ef-8bb7-9c2dcdaf01ba",

    // Section II - Hot Work/Hot Tapping - Items 1-9
    EQUIPMENT_INSPECTED_2: "281ddd36-d3de-11ef-8bb7-9c2dcdaf01ba",
    SEWERS_COVERED: "281dddc7-d3de-11ef-8bb7-9c2dcdaf01ba",
    ELECTRICAL_ISOLATED: "281e04b7-d3de-11ef-8bb7-9c2dcdaf01ba",
    EQUIPMENT_STATUS: "281e06ce-d3de-11ef-8bb7-9c2dcdaf01ba",
    VENTILATION: "281e0782-d3de-11ef-8bb7-9c2dcdaf01ba",
    SPARK_SHIELD: "281e080b-d3de-11ef-8bb7-9c2dcdaf01ba",
    EARTHING: "281e08a4-d3de-11ef-8bb7-9c2dcdaf01ba",
    CYLINDERS_OUTSIDE: "281e093f-d3de-11ef-8bb7-9c2dcdaf01ba",
    HAZARDS_CONSIDERED: "281e09cf-d3de-11ef-8bb7-9c2dcdaf01ba",

    // Right Column - Items 10-24
    IRON_SULPHIDE: "281e39bc-d3de-11ef-8bb7-9c2dcdaf01ba",
    FLAME_ARRESTER_EXHAUST: "281e3dd7-d3de-11ef-8bb7-9c2dcdaf01ba",
    AREA_CORDONED_TAGS: "281e3ea3-d3de-11ef-8bb7-9c2dcdaf01ba",
    HC_GAS_TESTING: "281e3f38-d3de-11ef-8bb7-9c2dcdaf01ba",
    H2S_GAS_TESTING: "281e4117-d3de-11ef-8bb7-9c2dcdaf01ba",
    O2_GAS_TESTING: "281e41dc-d3de-11ef-8bb7-9c2dcdaf01ba",
    SURROUNDING_AREA: "281e426c-d3de-11ef-8bb7-9c2dcdaf01ba",
    FIRE_WATER: "281e5d70-d3de-11ef-8bb7-9c2dcdaf01ba",
    EQUIPMENT_DRAINED: "281e5f78-d3de-11ef-8bb7-9c2dcdaf01ba",
    PORTABLE_EQUIPMENT: "281e5fea-d3de-11ef-8bb7-9c2dcdaf01ba",
    WELDING_MACHINE: "281e61cb-d3de-11ef-8bb7-9c2dcdaf01ba",
    STANDBY_PERSON: "281e72d0-d3de-11ef-8bb7-9c2dcdaf01ba",
    APPROVAL_HOT_TAPPING: "281e73ea-d3de-11ef-8bb7-9c2dcdaf01ba",
    EXIT_PROVIDED: "281e7441-d3de-11ef-8bb7-9c2dcdaf01ba",
    OIL_GAS_TRAPPED: "281e9c16-d3de-11ef-8bb7-9c2dcdaf01ba",
  };

  // Helper function to get checklist item by ID
  const getItem = (id) => checklistMap[id];

  // Helper function to render checkmark
  const renderCheckmark = (item, status) => {
    if (item && item.work_status === status) {
      return <span className="checkmarks">&#10003;</span>;
    }
    return "";
  };

  console.log("checklist hot work", checklist);

  return (
    <>
      <div className="hot-template-container">
        <div className="hot-template-container-content">
          <div className="template-container-header">
            <div className="hot-work-table">
              <table className="hot-work-tables">
                <thead>
                  <tr>
                    <th className="permit-center-align permit-2">Item</th>
                    <th className="permit-center-align permit-3">Done</th>
                    <th className="permit-center-align permit-4">Not Reqd.</th>
                    <th className="permit-center-align permit-2">Item</th>
                    <th className="permit-center-align permit-3">Done</th>
                    <th className="permit-center-align permit-4">Not Reqd.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      I. Road Closure Crane Operation/Vehicle Entry/
                      <br /> Photography
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.ROAD_CLOSURE), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.ROAD_CLOSURE), 0)}
                    </td>
                    <td>10. Iron sulphide removed & kept wet.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.IRON_SULPHIDE), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.IRON_SULPHIDE), 0)}
                    </td>
                  </tr>

                  <tr>
                    <td>1. Equipment & Area inspected</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED_1),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED_1),
                        0
                      )}
                    </td>
                    <td>11. Flame arrester on exhaust checked.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.FLAME_ARRESTER_EXHAUST),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.FLAME_ARRESTER_EXHAUST),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>2. Area cordoned off</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.AREA_CORDONED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.AREA_CORDONED),
                        0
                      )}
                    </td>
                    <td>
                      12. Area cordoned off & Precautionary Tag Boards
                      provided.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.AREA_CORDONED_TAGS),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.AREA_CORDONED_TAGS),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>3. Clearance From F&S Dept.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.CLEARANCE_FS),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.CLEARANCE_FS),
                        0
                      )}
                    </td>
                    <td>
                      13. HC gas testing(%LEL):
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.HC_GAS_TESTING)?.hc_gas ||
                          "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.HC_GAS_TESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.HC_GAS_TESTING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      4. Checked Flame/Spark Arrestor for mobile Eqpt. <br />{" "}
                      No/Vehicle Regd No:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.FLAME_ARRESTOR)
                          ?.vehicle_regd_no || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.FLAME_ARRESTOR),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.FLAME_ARRESTOR),
                        0
                      )}
                    </td>
                    <td>
                      14. H2S gas testing(PPM):
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.H2S_GAS_TESTING)?.h2s_gas ||
                          "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.H2S_GAS_TESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.H2S_GAS_TESTING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>5. Danger sign displayed</td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.DANGER_SIGN), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.DANGER_SIGN), 0)}
                    </td>
                    <td>
                      15. O2 gas testing(% by vol of air):
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.O2_GAS_TESTING)?.o2_gas ||
                          "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.O2_GAS_TESTING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.O2_GAS_TESTING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>II. Hot Work/Hot Tapping</td>
                    <td className="permit-center-align"></td>
                    <td className="permit-center-align"></td>
                    <td>
                      16. Surrounding area checked, cleaned up, oil, <br />{" "}
                      grass etc removed.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SURROUNDING_AREA),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SURROUNDING_AREA),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>1. Equipment & Area inspected</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED_2),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_INSPECTED_2),
                        0
                      )}
                    </td>
                    <td>
                      17. Fire Water hose, Portable extinguishers <br />{" "}
                      provided & system checked for readiness.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.FIRE_WATER), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.FIRE_WATER), 0)}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      2. Sewers, manholes, CBD etc & hot surface nearby covered
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SEWERS_COVERED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.SEWERS_COVERED),
                        0
                      )}
                    </td>
                    <td>18. Equipment properly drained & depressurized</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_DRAINED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_DRAINED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      3. Equipment Electrically isolated & tagged. <br />
                      Electrical Permit no:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.ELECTRICAL_ISOLATED)
                          ?.electrical_permit_no || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.ELECTRICAL_ISOLATED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.ELECTRICAL_ISOLATED),
                        0
                      )}
                    </td>
                    <td>
                      19. Portable equipment, Nozzles properly
                      <br /> grounded.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.PORTABLE_EQUIPMENT),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.PORTABLE_EQUIPMENT),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      4. Equipment: Blinded/Isolated/Disconnected/ <br />{" "}
                      Closed/Wedge open:
                      <span
                        style={{
                          padding: "0 4px",
                          display: "inline-block",
                          minWidth: "80px",
                        }}
                      >
                        {getItem(CHECKLIST_IDS.EQUIPMENT_STATUS)
                          ?.equipment_status || "..............."}
                      </span>
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STATUS),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EQUIPMENT_STATUS),
                        0
                      )}
                    </td>
                    <td>20. Welding machine checked for safe location</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.WELDING_MACHINE),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.WELDING_MACHINE),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>5. Proper ventilation & Lighting provided.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.VENTILATION), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.VENTILATION), 0)}
                    </td>
                    <td>21. Standby person provided for fire watch</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.STANDBY_PERSON),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.STANDBY_PERSON),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>6. Shield against spark provided</td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.SPARK_SHIELD), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.SPARK_SHIELD), 0)}
                    </td>
                    <td>
                      22. Approval obtained from inspection for Hot
                      <br /> Tapping.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.APPROVAL_HOT_TAPPING),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.APPROVAL_HOT_TAPPING),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      7. Check for earthing & return connection to the <br />
                      equipment being welded.
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.EARTHING), 1)}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(getItem(CHECKLIST_IDS.EARTHING), 0)}
                    </td>
                    <td>23. Proper means of exit/ escape provided.</td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EXIT_PROVIDED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.EXIT_PROVIDED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      8. Oxygen & Acetylene cylinders kept outside the
                      vessel/tank
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.CYLINDERS_OUTSIDE),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.CYLINDERS_OUTSIDE),
                        0
                      )}
                    </td>
                    <td rowSpan="2">
                      24. Checked for oil & gas trapped behind the lining <br />
                      in Equipment.
                    </td>
                    <td rowSpan="2" className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.OIL_GAS_TRAPPED),
                        1
                      )}
                    </td>
                    <td rowSpan="2" className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.OIL_GAS_TRAPPED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      9. Considered hazards from routine/ non routine <br />
                      operations & concerned persons alerted
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.HAZARDS_CONSIDERED),
                        1
                      )}
                    </td>
                    <td className="permit-center-align">
                      {renderCheckmark(
                        getItem(CHECKLIST_IDS.HAZARDS_CONSIDERED),
                        0
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td colSpan="6">
                      Gas Test Done By:{" "}
                      <strong>
                        {fireSafetySignature?.name ||
                          "................................................"}
                      </strong>
                      &nbsp;&nbsp; Signature:{" "}
                      <strong>
                        ..............................................
                      </strong>
                      &nbsp;&nbsp; Date & Time:{" "}
                      <strong>
                        {fireSafetySignature
                          ? new Date(
                              fireSafetySignature.date_time
                            ).toLocaleString()
                          : "........................................................"}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HotWorkTemplate4;